import DesktopMenuItem from './desktopmenuitem';
import {useDesktopMenu} from './state';

const {prefixCSS} = polyphony.css;

const styles = {
    wrapper: prefixCSS({
        pointerEvents: 'auto',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginRight: 10,
        listStyleType: 'none',
        height: '100%',
        paddingTop: 20,
        paddingBottom: 20,
        boxSizing: 'border-box'
    })
};

const DesktopMenu = () => {
    const {items, setHoveredItem} = useDesktopMenu();
    return (
        <ul role='menubar' aria-live='polite' onMouseLeave={() => setHoveredItem(null)} style={styles.wrapper} aria-label='Navigation'>
            {items.map((x, i) => <DesktopMenuItem
                                     key={x.id}
                                     parent={null}
                                     item={x}
                                     index={i}
                                     isFirst={i === 0}
                                     isLast={i === items.length - 1} />)}
        </ul>
    );
};

DesktopMenu.displayName = 'DesktopMenu';

export default DesktopMenu;

